import React, { useState, useEffect } from 'react'
import netlifyIdentity from 'netlify-identity-widget'
import { Link } from 'react-scroll'

import Container from '../../layout/container'
import { HeaderStyle, Menu, OpenMenu, CloseMenu, Button } from './style'

import Logo from '../../assets/logo.png'
import Logo2 from '../../assets/logo2.svg'

export default function Header({ page }) {
  const [activeDash, setActiveDash] = useState(false);
  const [activeMenu, setActiveMenu] = useState(false);

  const toggleActiveDash = () => setActiveDash(value => !value);
  const toggleActiveMenu = () => setActiveMenu(value => !value);  

  const currentUser = netlifyIdentity.currentUser();

  const signOut = () => {
    netlifyIdentity.logout()
    netlifyIdentity.on('logout', () => {
      window.location.href = '/';
    });
  }

  useEffect(() => {
    netlifyIdentity.init({});
  }, []);
  
  return (
    <HeaderStyle className={page === 'dash' ? 'dash' : ''}>
      <Container>
        <a href="/">
          <img alt="Boticário" title="Boticário" src={page === 'dash' ? Logo2 : Logo} className="logo" />
        </a>

        <OpenMenu onClick={toggleActiveMenu} />

        <Menu open={activeMenu}>
          {page === 'dash' ?
            ''
          : page === 'blog' ?
            <>
              <CloseMenu onClick={toggleActiveMenu} />

              <img alt="Boticário" title="Boticário" src={page === 'dash' ? Logo2 : Logo} className="logoMobile" />

              <li>
                <a href="/#beneficios" onClick={() => setActiveMenu(false)}>
                  Benefícios
                </a>
              </li>
              <li>
                <a href="/#productos" onClick={() => setActiveMenu(false)}>
                  Productos
                </a>
              </li>
              <li>
                <a href="/#especiales" onClick={() => setActiveMenu(false)}>
                  ¿Qué nos hace especiales?
                </a>
              </li>
              <li>
                <a href="/#comofunciona" onClick={() => setActiveMenu(false)}>
                  Cómo funciona
                </a>
              </li>
              <li>
                <a href="/#registro" onClick={() => setActiveMenu(false)}>
                  Registro
                </a>
              </li>
              <li>
                <a href="/blog" onClick={() => setActiveMenu(false)}>Blog</a>
              </li>
              <li>
                <a href="/#preguntas" onClick={() => setActiveMenu(false)}>
                  ¿Preguntas?
                </a>
              </li>
            </>
          :  <>
              <CloseMenu onClick={toggleActiveMenu} />

              <img alt="Boticário" title="Boticário" src={page === 'dash' ? Logo2 : Logo} className="logoMobile" />

              <li>
                <Link to="beneficios" spy={true} smooth={true} duration={500} onClick={() => setActiveMenu(false)}>
                  Benefícios
                </Link>
              </li>
              <li>
                <Link to="productos" spy={true} smooth={true} duration={500} onClick={() => setActiveMenu(false)}>
                  Productos
                </Link>
              </li>
              <li>
                <Link to="especiales" spy={true} smooth={true} duration={500} onClick={() => setActiveMenu(false)}>
                  ¿Qué nos hace especiales?
                </Link>
              </li>
              <li>
                <Link to="comofunciona" spy={true} smooth={true} duration={500} onClick={() => setActiveMenu(false)}>
                  Cómo funciona
                </Link>
              </li>
              <li>
                <Link to="registro" spy={true} smooth={true} duration={500} onClick={() => setActiveMenu(false)}>
                  Registro
                </Link>
              </li>
              <li>
                <a href="/blog" onClick={() => setActiveMenu(false)}>Blog</a>
              </li>
              <li>
                <Link to="preguntas" spy={true} smooth={true} duration={500} onClick={() => setActiveMenu(false)}>
                  ¿Preguntas?
                </Link>
              </li>
            </>
          }

          {currentUser ?
            <li className="toDash" onClick={toggleActiveDash}>
              <div className="toDash--link">
                Hola, {currentUser.user_metadata.full_name ? currentUser.user_metadata.full_name : currentUser.email}
              </div>

              <i></i>

              {activeDash ? 
                <div className="toDash--menu">
                  <a href="/dashboard">Dashboard</a>
                  <Button onClick={() => signOut()}>
                    Log Out
                  </Button>
                </div>
              : ''}
            </li>
          : ''}
        </Menu>
      </Container>

      {activeMenu ?
        <div className="overlay" onClick={toggleActiveMenu}></div>
      : ''}
    </HeaderStyle>
  )
}